// 年収診断フォームのバリデーション
// vuelidateのラッパーなので、利用の際はvuelidateのドキュメント(https://vuelidate-next.netlify.app/)も参照ください。
import { useVuelidate } from '@vuelidate/core';
import { required, maxLength, email, helpers } from '@vuelidate/validators';
import { annualIncomeFormat } from '@/javascripts/utils/custom_validators';
import { rules } from '@/javascripts/composables/inquiry/validation';

import type { Ref } from 'vue';
import type { ValidationRuleCollection } from '@vuelidate/core';
import type Inquiry from '@/javascripts/utils/inquiry';
import type { InquiryValidation } from '@/javascripts/composables/inquiry/validation';

/** バリデーションする項目 */
export type ValidationKey =
  'employmentTypeCd' | 'wishfulTimeCd' | 'prefectureCd' |
  'lastName' | 'firstName' | 'lastNameKana' | 'firstNameKana' |
  'birthYearCd' | 'phone' | 'email' | 'comment' |
  'annualIncome' | 'callAcceptance' | 'genderTypeCd';

type ValidationRules = {
  [keys in ValidationKey]: ValidationRuleCollection<Inquiry[keys]>
};

const shindanValidationRules: ValidationRules = {
  ...rules,
  email: {
    required: helpers.withMessage('メールアドレスを入力してください', required),
    email: helpers.withMessage('メールアドレスが正しくありません', email),
    maxLength: helpers.withMessage('80文字以内で入力してください', maxLength(80))
  },
  genderTypeCd: {
    required: helpers.withMessage('性別を選択してください', required)
  },
  annualIncome: {
    required: helpers.withMessage('現在の年収を入力してください', required),
    numeric: helpers.withMessage('半角数字で正しい年収を入力してください', annualIncomeFormat),
    maxLength: helpers.withMessage('4桁以内で入力してください', maxLength(4))
  },
  callAcceptance: {
    required: helpers.withMessage('電話でのご連絡を希望するか選択してください', required)
  },
  comment: {
    maxLength: helpers.withMessage('400文字以内で入力してください', maxLength(400))
  }
}

/** バリデーション対象となる問い合わせオブジェクト */
type InquiryObj = Pick<Inquiry, ValidationKey>;

/**
 * 診断フォームのバリデーションに関するコンポーザブル関数(バリデーション項目を指定)
 * @param inquiry バリデーションする問い合わせインスタンス
 * @param validationFields バリデーションする項目
 */
export default function useShindanInquiryValidation(inquiry: InquiryObj | Ref<InquiryObj>): Ref<InquiryValidation> {
  return useVuelidate(shindanValidationRules, inquiry, { $autoDirty: true });
}
